﻿/**
 * app.config
 * @namespace portal
 */

(function () {
	'use strict';

	/** configure the nha.portal module */
	angular.module('nha.portal').config(config);

	/** injection */
	config.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$breadcrumbProvider', '$sceDelegateProvider', '$compileProvider', 'RestangularProvider', 'appSettings'];

	/** implementation */
	function config($stateProvider, $urlRouterProvider, $locationProvider, $breadcrumbProvider, $sceDelegateProvider, $compileProvider, RestangularProvider, appSettings) {
		/** whitelist domains that we need to communicate with */
		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			'https://*.nhatest.com/**',
			'https://*.mynhadev.com/**',
			'https://*.nhaschools.com/**', 'https://*.mynha.com/**', 'https://mynha.com/**'
		]);

		/** enable/disable debug info */
		if (appSettings.environment !== 'dev' && appSettings.environment !== 'ci') {
			$compileProvider.debugInfoEnabled(false);
		}

		/** use HTML5 History API */
		$locationProvider.html5Mode({ enabled: true, requireBase: true });

		/** set default path */
		$urlRouterProvider.otherwise('/');

		/** configure Restangular */
		RestangularProvider.setBaseUrl(appSettings.portalServicesRootUrl);

		/** grab our breadcrumb template root */
		$breadcrumbProvider.setOptions({
			templateUrl: appSettings.coreWebRootUrl + 'app/directives/breadcrumb/breadcrumb.html',
			includeAbstract: true
		});
	}
})();